export class KeyValuesViewModel {
    key: any;
    values: object[];
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/view-model/keyValues.viewModel.ts